import { Redirect } from 'expo-router';
import { View } from 'react-native';

import { Bounded } from '@/components/ui/Bounded';
import { BrandMark } from '@/components/ui/BrandMark';
import { Button } from '@/components/ui/Button';
import { Screen } from '@/components/ui/Screen';
import { Text } from '@/components/ui/Text';
import { useAuth } from '@/lib/auth';

export default function LandingScreen() {
  const { session, status } = useAuth();

  if (status === 'ready' && session) return <Redirect href="/" />;

  return (
    <Screen className="justify-between">
      <Bounded className="flex-1 justify-center gap-8 px-6">
        <BrandMark size="lg" />
        <View className="gap-4">
          <Text variant="display">Nothing left{'\n'}on the ground.</Text>
          <Text variant="subtitle">
            Build a checklist once. Run it every time — any order, with your crew, sealed
            when it&apos;s done.
          </Text>
        </View>
      </Bounded>

      <Bounded className="gap-3 px-6 pb-4">
        <Button block label="Get started" href="/sign-up" />
        <Button
          block
          variant="ghost"
          label="Already have an account? Sign in"
          href="/sign-in"
        />
      </Bounded>
    </Screen>
  );
}
